export const DEPENDENT_RELATIONSHIPS = {
  SPOUSE: "15",
  CHILD: "16",
  OTHER: "-16"
};

export const VALIDATION_CONSTRAINTS = {
  MIN_DEPENDENT_AGE_DAYS: 30,
  MAX_CHILD_AGE: 23,
  COVERAGE_DATE_RANGE: {
    MIN_DAYS_BEFORE: -15,
    MAX_DAYS_AFTER: 45
  }
};

export const NAME_LENGTH = {
  MIN: 2,
  MAX: 100
};

export const FAVORITE_PLAN_NAME_LENGTH = {
  MIN: 5,
  MAX: 50
};

export const MAIN_APPLICANT_FIELDS = [
  "name",
  "surname", 
  "email",
  "gender",
  "country",
  "coverage",
  "birthday"
];

export const DEPENDENT_FIELDS = [
  "name",
  "surname",
  "gender", 
  "country",
  "birthday",
  "componentId"
];

export const ERROR_TYPES = {
  EMPTY: 'empty',
  INVALID: 'invalid',
  BLANK: 'blank',
  INVALID_INPUT_SON: 'invalidInputSon',
  INVALID_INPUT_OTHER: 'invalidInputOther', 
  INVALID_INPUT_SPOUSE: 'invalidInputSpouse',
  BAD_ENTRY: 'badEntry'
};

export const AGE_LIMITS = {
  MIN_AGE: 18,
  MAX_AGE: 75
};

// Cada valor es el `step` lógico que useSteps.jsx#getAllSteps le asigna a la
// ruta (no el número de la URL - por reordenamientos históricos, ya no
// coinciden: el Summary con los checkboxes de aceptación vive en /step8,
// pero su `step` lógico es 11; /step9 es una página aparte (envío de
// PDF/email) con `step: 12`, y /step14 es el que tiene `step: 9`).
export const VALIDATION_STEPS = {
  STEP_2: 2,
  STEP_4: 4,
  STEP_5: 5,
  STEP_6: 6,
  STEP_8: 8,
  // Summary (/step8): checkboxes de aceptación (acceptNonRegion/acceptNonRegion2).
  STEP_11: 11
};

export const BENEFIT_VALIDATION_KEYS = {
  MATERNITY_AND_CESAREAN: 'Maternity and cesarean',
  MATERNITY: 'matrnity',
  MATERNITY_NO_VALUE: 'matrnity_no',
  MATERNITY_ID_182: '182'
};

export const GEO_VALIDATION = {
    WORLDWIDE: 'wwide',
    PROVIDER_GLOBAL_OPEN: 'glopen'
};

export const COUNTRY_ISO_NUM = {
    USA: "840",
    COLOMBIA: "170",
};

export const USA_CHILD_LABELS = {
  es: "Temporalmente Expatriado 1",
  en: "Temporally Expat 1",
  pt: "Temporariamente Expat 1"
};
